// extracted by mini-css-extract-plugin
export default {"button":"ChevronRightButton_button__5ImeC"};